import FILTERED_TYPE, {
  FILTERED_COLUMNS_KEY,
  FILTERED_COLUMNS_OUTPUT_KEY
} from './constant'
import { find, isEmpty, isUndefined, keys, filter } from 'lodash'

export const updateUserFilteredColumns = ({
  identifier,
  model,
  userId,
  nameFilter,
  type
}) => {
  if (isEmpty(identifier) || isUndefined(userId)) return

  const localStorageFilteredColumns = getStoreObject(type)
  const storedObjectByUser = getUserFilteredColumnsStorageByUser(userId, type)

  const filterAlreadyExist = keys(storedObjectByUser).includes(identifier)

  const newObjectToStorage = filterAlreadyExist
    ? {
        [identifier]: [
          ...storedObjectByUser[identifier],
          { name: nameFilter, model, selected: false }
        ]
      }
    : {
        [identifier]: [{ name: nameFilter, model, selected: false }]
      }

  const objectToSave = isEmpty(localStorageFilteredColumns)
    ? {
        [userId]: newObjectToStorage
      }
    : {
        ...localStorageFilteredColumns,
        [userId]: { ...storedObjectByUser, ...newObjectToStorage }
      }

  updateStoreObject({ type, objectToSave })
}

export const getUserFilteredColumnsStorageByUser = (userId, type) => {
  const lockedColumnsStorage = getStoreObject(type)
  return lockedColumnsStorage[userId] || {}
}

const getStoreObject = (type) => {
  // eslint-disable-next-line no-undef
  return JSON.parse(localStorage.getItem(getKeyByType(type))) || {}
}

const updateStoreObject = ({ type, objectToSave }) => {
  // eslint-disable-next-line no-undef
  localStorage.setItem(getKeyByType(type), JSON.stringify(objectToSave))
}

const getKeyByType = (type) => {
  // INPUTVIEW OR OUTPUT
  return type === FILTERED_TYPE.TABLE
    ? FILTERED_COLUMNS_KEY
    : FILTERED_COLUMNS_OUTPUT_KEY
}

export const isNameAlreadyStored = (filterName, type, identifier, userId) => {
  const storedObjectByUser = getUserFilteredColumnsStorageByUser(userId, type)
  const wtAlreadyExist = keys(storedObjectByUser).includes(identifier)

  if (!wtAlreadyExist) {
    // object does not already exist
    return false
  } else {
    const findObj = find(storedObjectByUser[identifier], { name: filterName })
    return !isUndefined(findObj)
  }
}

export const removeFromStoreByName = (filterName, type, identifier, userId) => {
  const storedObjectByUser = getUserFilteredColumnsStorageByUser(userId, type)

  if (storedObjectByUser && !isEmpty(storedObjectByUser)) {
    const filteredObject = filter(
      storedObjectByUser[identifier],
      ({ name }) => name !== filterName
    )

    const localStorageFilteredColumns = getStoreObject(type)

    const newObjectToStorage = {
      [identifier]: filteredObject
    }

    const objectToSave = {
      ...localStorageFilteredColumns,
      [userId]: { ...storedObjectByUser, ...newObjectToStorage }
    }
    updateStoreObject({ type, objectToSave })
    return true
  }
  return false
}

export const getDefaultFilter = ({ userId, identifier, type }) => {
  const storedObjectByUser = getUserFilteredColumnsStorageByUser(userId, type)
  const filters = storedObjectByUser[identifier]
  if (isEmpty(filters)) return { id: 'none', model: {} }
  const selectedObj = filters.find(({ selected }) => selected)
  if (isEmpty(selectedObj)) return { id: 'none', model: {} }
  return selectedObj
}

export const saveSelectedFilter = ({
  selectedFilter,
  userId,
  identifier,
  type
}) => {
  const storedObjectByUser = getUserFilteredColumnsStorageByUser(userId, type)
  if (!storedObjectByUser) return
  const filters = storedObjectByUser[identifier]
  const newFilters = filters.map((filter) => ({
    ...filter,
    selected: filter.name === selectedFilter
  }))

  const localStorageFilteredColumns = getStoreObject(type)

  const newObjectToStorage = {
    [identifier]: newFilters
  }

  const objectToSave = {
    ...localStorageFilteredColumns,
    [userId]: { ...storedObjectByUser, ...newObjectToStorage }
  }
  updateStoreObject({ type, objectToSave })
}
